import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_JOB_PACKS = restRequest(
    "VRCORE.JOB_PACK_MANAGER.GET_JOB_PACKS"
);
export const GET_JOB_PACKS2 = restRequest(
    "VRCORE.JOB_PACK_MANAGER.GET_JOB_PACKS2"
);
export const GET_JOB_PACKSMODAL = restRequest(
    "VRCORE.JOB_PACK_MANAGER.GET_JOB_PACKSMODAL"
);
export const GET_DEPARTMENTS = restRequest(
    "VRCORE.JOB_PACK_MANAGER.GET_DEPARTMENTS"
);
export const GET_AREAS = restRequest("VRCORE.JOB_PACK_MANAGER.GET_AREAS");
export const SET_JOB_YEAR = "VRCORE.JOB_PACK_MANAGER.SET_JOB_YEAR";
export const SET_JOB_MONTH = "VRCORE.JOB_PACK_MANAGER.SET_JOB_MONTH";
export const SET_DATE_FROM = "VRCORE.JOB_PACK_MANAGER.SET_DATE_FROM";
export const SET_DATE_TO = "VRCORE.JOB_PACK_MANAGER.SET_DATE_TO";
export const SET_FILTER_STATUS = "VRCORE.JOB_PACK_MANAGER.SET_FILTER_STATUS";
export const SET_DEPARTMENT_STATUS =
    "VRCORE.JOB_PACK_MANAGER.SET_DEPARTMENT_STATUS";
export const SET_AREA_STATUS = "VRCORE.JOB_PACK_MANAGER.SET_AREA_STATUS";
export const SET_SEARCH_JOB_ID = "VRCORE.JOB_PACK_MANAGER.SET_SEARCH_JOB_ID";
export const SET_ROW = "VRCORE.JOB_PACK_MANAGER.SET_ROW";
export const SET_PAGE = "VRCORE.JOB_PACK_MANAGER.SET_PAGE";
export const POST_JOB_PACK_STATUS = restRequest(
    "VRCORE.JOB_PACK_MANAGER.POST_JOB_PACK_STATUS"
);
export const SET_VIEW_TYPE = "SET_VIEW_TYPE";
export const SET_SORT_TABLE_TYPE = "SET_SORT_TABLE_TYPE";
export const SET_SORT_TABLE_KEY = "SET_SORT_TABLE_KEY";
export const SET_STATUS = "SET_STATUS";
export const SET_ROW_COUNT = "SET_ROW_COUNT";
export const SET_PAGE_INDEX = "SET_PAGE_INDEX";
export const SET_CLICKED_STATUS_JOB_ID = "SET_CLICKED_STATUS_JOB_ID";
export const SET_MODAL_OPEN = "SET_MODAL_OPEN";
export const SET_SNACKBAR_OPEN = "SET_SNACKBAR_OPEN";
export const SET_SORT_TABLE_AS = "SET_SORT_TABLE_AS";

export const MOVE_JOBPACK_PENDING = restRequest(
    "VRCORE.JOB_PACK_MANAGER.MOVE_JOBPACK_PENDING"
);
export const MOVE_JOBPACK = restRequest("VRCORE.JOB_PACK_MANAGER.MOVE_JOBPACK");
export const REMOVE_JOBPACK = restRequest(
    "VRCORE.JOB_PACK_MANAGER.REMOVE_JOBPACK"
);
export const MOVE_JOBPACK_ARCHIVED = restRequest(
    "VRCORE.JOB_PACK_MANAGER.MOVE_JOBPACK_ARCHIVED"
);
export const GET_REGISTERED_USERS = restRequest(
    "VRCORE.JOB_PACK_MANAGER.GET_REGISTERED_USERS"
);
export const SET_TABLE = restRequest("VRCORE.JOB_PACK_MANAGER.SET_TABLE");
export const SET_DAY = restRequest("VRCORE.JOB_PACK_MANAGER.SET_DAY");
export const ARCHIEVE_JOBPACK = restRequest(
    "VRCORE.JOB_PACK_MANAGER.ARCHIEVE_JOBPACK"
);
export const GET_TEMPLATES = restRequest(
    "VRCORE.JOB_PACK_MANAGER.GET_TEMPLATES"
);
export const SET_FILTER_TEMPLATE = restRequest(
    "VRCORE.JOB_PACK_MANAGER.SET_FILTER_TEMPLATE"
);
export const TOGGLE_AREAS_DEPT = restRequest(
    "VRCORE.JOB_PACK_MANAGER.TOGGLE_AREAS_DEPT"
);
export const SET_SEARCH_JOB_URN = "VRCORE.JOB_PACK_MANAGER.SET_SEARCH_JOB_URN";
